import GuestModePages from "../components/GuestMode";
const GuestMode = () => {
  return (
    <>
      <GuestModePages />
    </>
  );
};

export default GuestMode;
